import { Action } from './types'
import { LoginView } from '../reducers'

export const uiWorking = (): Action => ({
  type: 'UI_WORKING'
})

export const uiWorkDone = (): Action => ({
  type: 'UI_WORK_COMPLETE'
})

export const showNotification = (message: string): Action => ({
  type: 'SHOW_NOTIFICATION',
  payload: message
})

export const hideNotification = (): Action => ({
  type: 'HIDE_NOTIFICATION'
})

export const showLoginForm = (view: LoginView = 'login'): Action => ({
  type: 'SHOW_LOGIN_FORM',
  payload: view
})

export const hideLoginForm = (): Action => ({
  type: 'HIDE_LOGIN_FORM'
})

export const hideSignUpForm = (): Action => ({
  type: 'HIDE_SIGNUP_FORM'
})

export const signUpNextForm = (email: string): Action => ({
  type: 'SIGNUP_NEXT_FORM',
  payload: email
})

export const hideRegisteredForm = (email): Action => ({
  type: 'HIDE_REGISTERED_FORM',
  payload: email
})



// WEBPACK FOOTER //
// ./src/actions/ui_actions.ts